import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../../../Baseurl";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2"; // Import SweetAlert2
import { Trash2, XSquare, Home } from "react-feather"; 
import defaultfile from "../../../component/img/defaultfile1.png";

const AllThumbnail = () => {
  const navigate = useNavigate();
  const { listing_id } = useParams();
  const [thumbnails, setThumbnails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchThumbnails = async () => {
      try {
        const response = await axios.get(`${baseurl}seller/thumbnails/${listing_id}`);
        if (response.data.message === "Listing File fetched successfully.") {
          if (response.data.data && response.data.data.length > 0) {
            setThumbnails(response.data.data);
          } else {
            console.log("No thumbnails found for this listing.");
            setThumbnails([]);
          }
        }
      } catch (error) {
        console.error("Error fetching thumbnails:", error);
        if (error.response && error.response.status !== 404) {
          Swal.fire({
            icon: "error",
            title: "Failed to load thumbnails",
            text: "There was an error while fetching the thumbnails.",
          });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchThumbnails();
  }, [listing_id]);

  const handleDelete = async (thumbnailId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this action!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${baseurl}seller/delete-thumbnail/${thumbnailId}`);
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Listing File Deleted',
            text: 'The Listing File has been successfully deleted.',
          });
          setThumbnails(thumbnails.filter(thumbnail => thumbnail.id !== thumbnailId));
        }
      } catch (error) {
        console.error('Error deleting thumbnail:', error);
        Swal.fire({
          icon: 'error',
          title: 'Delete Failed',
          text: 'There was an error while deleting the thumbnail. Please try again.',
        });
      }
    }
  };

  const handleSetDefault = async (thumbnailId) => {
    try {
      console.log("Sending request to set default thumbnail with ID:", thumbnailId);
  
      const response = await axios.post(`${baseurl}setDefaultThumbnail/${thumbnailId}`);
  
      console.log("Server Response:", response.data);
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Default Thumbnail Set',
          text: 'The selected thumbnail has been set as the default.',
        }).then(() => {
          window.location.reload(); // Reload the page after user clicks "OK"
        });
      }
    } catch (error) {
      console.error('Error setting default thumbnail:', error);
  
      if (error.response) {
        console.error("Server Error Response:", error.response.data);
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Failed to Set Default',
        text: 'There was an error while setting the default thumbnail. Please try again.',
      });
    }
  };
  
  

  return (
    <div> 
      {loading ? (
        <div class="d-flex justify-content-center align-items-center ">
          <div class="spinner-border text-danger" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="thumbnail-grid">
          {thumbnails.length > 0 ? (
            thumbnails.map((thumbnail) => {
              const fileName = thumbnail.listing_image.toLowerCase();
              const fileUrl = `${imageUrl}listing/${thumbnail.listing_image}`;

              // File type detection
              const isImage = [".jpg", ".jpeg", ".png", ".gif", ".webp"].some(ext => fileName.endsWith(ext));
              const isVideo = fileName.endsWith(".mp4");

              return (
                <div key={thumbnail.id}>
                  <div className="thumbnail-box">
                    {/* Render Image */}
                    {isImage ? (
                      <div>
                        <img src={fileUrl} alt="listing" className="thumbnail-image" />
                      </div>
                    ) : isVideo ? (
                      // Render Video
                      <video className="thumbnail-image" controls>
                        <source src={fileUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      // Render Generic Preview for Other File Types
                      <div className="other-file-preview">
                        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                          <img src={defaultfile} alt={thumbnail.listing_image} className="thumbnail-image" />
                          <p className="demasa">"Click To View Or Download."</p>
                        </a>
                      </div>
                    )}

                    {/* Delete Button */}
                    <button className="btn btn-danger delete-btn" onClick={() => handleDelete(thumbnail.id)}>
                      <XSquare />
                    </button>
                  </div>

                  {/* Set Default Button */}
                  <div>
  {thumbnail.default !== "yes" && (
    <button className="btn btn-primary mt-2" onClick={() => handleSetDefault(thumbnail.id)}>
      Set Default
    </button>
  )}
</div>

                </div>
              );
            })
          ) : (
            <p className="text-center">No thumbnails found.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default AllThumbnail;
